import { createLayoutComponent } from "./Layout.mjs";
export default createLayoutComponent(true);